import {
  POST_TYPE_GUIDE,
  POST_TYPE_PAGE,
  POST_TYPE_BLOG_POST,
  POST_TYPE_PRODUCT_TEST,
  POST_TYPE_CATEGORY,
  POST_TYPE_PRODUCT,
} from 'src/constants'

import type { PostType } from 'src/types/Post'

export const getPostType = (rawPostType: string): PostType => {
  switch (rawPostType) {
    case 'post':
      return POST_TYPE_BLOG_POST
    case 'page':
      return POST_TYPE_PAGE
    case 'guides':
      return POST_TYPE_GUIDE
    case 'producttest':
      return POST_TYPE_PRODUCT_TEST
    case 'sw_category':
      return POST_TYPE_CATEGORY
    case 'product':
      return POST_TYPE_PRODUCT
    default:
      throw new Error(`Cannot find an post type match for "${rawPostType}".`)
  }
}
